import { PhysicalIdURI } from "@cur8/uri";

export function isPhysicalIdURI(source: unknown): source is PhysicalIdURI {
  return source instanceof PhysicalIdURI;
}
